﻿cb.define([], function () {
	var AA_aa_paramadjust_VM_Extend = {
		doAction: function (name,viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {
		var mode = viewmodel.getParams().mode;
		var self = this;
	/* 	  viewmodel.on("afterLoadData",function (data) {
			  var detailsModel = viewmodel.get("Paramadjuststore");
			  if(mode=="add"){
            viewmodel.get("btnAddRoww").setVisible(true);
			viewmodel.get("btnAddRoww").setDisabled(false);
				}
	   if(mode=="browse"){
		    viewmodel.get("btnAddRoww").setVisible(false);
				var rows = detailsModel.getRows();
						rows.forEach(function(rows,index){
							detailsModel.get("btnDeleteRoww").setVisible(false);
						});
	   }
						if(mode=="edit"){
		    viewmodel.get("btnAddRoww").setVisible(true);
            viewmodel.get("btnSaveAndAdd").setVisible(false);

						}
        });  */
		
		var storesModel = viewmodel.get("Paramadjuststore");
			if(storesModel) {
				storesModel.on('beforeBrowse', function(data) {
					if(data) {
						switch(data.cellName) {
							case "iStoreid_name":
							debugger
								//当前页面已选择的门店不再在参照面板中出现
								var rows = storesModel.getRows();
								var storeids = [];
								rows.forEach(function(item, index) {
									if(data.rowIndex === index) return;
									if(item.iStoreid_name === undefined) return;
									storeids.push(item.iStoreid);
								})
								var condition = {
									"isExtend": true,
									simpleVOs: []
								};
								if(storeids) {
									condition.simpleVOs.push({
										field: 'id',
										op: 'nin',
										value1: storeids
									});
								}
								data.context.setFilter(condition);
								break;
						}
					}
				});
			}
			
				var storesModel = viewmodel.get("Paramadjustparam");
			if(storesModel) {
				storesModel.on('beforeBrowse', function(data) {
					if(data) {
						switch(data.cellName) {
							case "paramid_name":
							debugger
								//当前页面已选择的门店不再在参照面板中出现
								var rows = storesModel.getRows();
								var paramids = [];
								rows.forEach(function(item, index) {
									if(data.rowIndex === index) return;
									if(item.paramid_name === undefined) return;
									paramids.push(item.paramid);
								})
								var condition = {
									"isExtend": true,
									simpleVOs: []
								};
								if(paramids) {
									condition.simpleVOs.push({
										field: 'id',
										op: 'nin',
										value1: paramids
									});
								}
								data.context.setFilter(condition);
								break;
						}
					}
				});
			}
    }
	
	}

	try {		
		module.exports = AA_aa_paramadjust_VM_Extend;
	} catch (error) {

	}
	return AA_aa_paramadjust_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_paramadjust_VM.Extend.js